import uniq from 'lodash-es/uniq';
import {
    BrandsFetchFailureAction,
    BrandsFetchRequestAction,
    BrandsFetchSuccessAction,
    STROLLERS_BRANDS_LIST_FETCH_FAILURE,
    STROLLERS_BRANDS_LIST_FETCH_REQUEST,
    STROLLERS_BRANDS_LIST_FETCH_SUCCESS,
} from 'mk2/apps/strollers/containers/BrandsList/BrandsList.actions';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { LoadingState, loadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

import { tupdate } from 'mk2/helpers/types';

export interface BrandsState {
    brandIds: number[];
    guideArticleIds: number[];
    strollersCounsellingId: number;
    loadingState: LoadingState;
    errorMessage: string;
    hasMore: boolean;
}

export const initialBrandsListState: BrandsState = {
    brandIds: [],
    guideArticleIds: [],
    strollersCounsellingId: null,
    loadingState: LoadingState.INIT,
    errorMessage: null,
    hasMore: false,
};

/**
 * Defaults to true till the server don't say other response
 *
 * @param state
 * @param action
 * @returns {boolean}
 */
const hasMore: Reducer<boolean> = (state: boolean = true, action: BrandsFetchSuccessAction) => {
    switch (action.type) {
        case STROLLERS_BRANDS_LIST_FETCH_SUCCESS:
            return action.hasMore;
        default:
            return state;
    }
};

type BrandsFetchAction =
    BrandsFetchRequestAction
    | BrandsFetchSuccessAction
    | BrandsFetchFailureAction;

export const brandsReducer: Reducer<BrandsState> = (state = initialBrandsListState, action: BrandsFetchAction) => {
    switch (action.type) {
        case STROLLERS_BRANDS_LIST_FETCH_REQUEST:
        case STROLLERS_BRANDS_LIST_FETCH_FAILURE:
            return tupdate(state, {
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
            });

        case STROLLERS_BRANDS_LIST_FETCH_SUCCESS:
            const brands = uniq([ ...state.brandIds, ...action.response.result.brands ]);

            return tupdate(state, {
                brandIds: brands,
                hasMore: hasMore(state.hasMore, action),
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
                guideArticleIds: action.response.result.guideArticles,
                strollersCounsellingId: action.response.result.strollersCounselling,
            });

        default:
            return state;
    }
};

export default brandsReducer;
